import React from 'react';
import type { FeedbackItem, FreeInputFeedbackConfig } from '../../../../../types/course';
import FloatingLabelPill from '../shared/FloatingLabelPill';
import SectionHeader from '../shared/SectionHeader';
import TrashButton from '../shared/TrashButton';

interface ItemEditorProps {
  item: Extract<FeedbackItem, { type: 'free_input_feedback' }>;
  onChange: (patch: Partial<Extract<FeedbackItem, { type: 'free_input_feedback' }>>) => void;
  onDelete: () => void;
  readOnly?: boolean;
}

export default function FreeInputFeedbackItem({ item, onChange, onDelete, readOnly }: ItemEditorProps) {
  const { question, max_length } = item.config;

  const updateConfig = (patch: Partial<FreeInputFeedbackConfig>) => {
    onChange({ config: { ...item.config, ...patch } });
  };

  return (
    <div className="flex flex-col gap-[31px] w-full">
      <SectionHeader title="Free-text feedback" />
      <FloatingLabelPill
        label="Question"
        value={question}
        onChange={(v) => updateConfig({ question: v })}
        placeholder="What would you like to ask?"
        size="xl"
        readOnly={readOnly}
        trailingIcon={!readOnly && <TrashButton onClick={onDelete} ariaLabel="Delete question" />}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <label className="flex flex-col gap-2 font-sans text-xs text-text-secondary">
          Max length (optional)
          <input
            type="number"
            min={1}
            value={max_length ?? ''}
            onChange={(e) =>
              updateConfig({
                max_length: e.target.value === '' ? undefined : Number(e.target.value),
              })
            }
            disabled={readOnly}
            placeholder="e.g. 2000"
            className="h-10 px-3.5 rounded-full border border-text-secondary bg-transparent text-text-primary font-sans text-sm outline-none focus:border-primary-500 transition-colors"
          />
        </label>
        <label
          className={`flex items-end gap-2 self-end pb-2 font-sans text-[13px] text-text-secondary ${
            readOnly ? 'cursor-default' : 'cursor-pointer'
          }`}
        >
          <input
            type="checkbox"
            checked={!!item.required}
            onChange={(e) => onChange({ required: e.target.checked })}
            disabled={readOnly}
            className="accent-primary-500"
          />
          Required
        </label>
      </div>
    </div>
  );
}
